import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import api from "../lib/api";
import { DEFAULTS } from "../lib/contentSchema";

const Ctx = createContext({ get: (k) => DEFAULTS[k], reload: () => {}, loaded: false });

/** Loads admin-edited website content once. Until it arrives (or if the request fails) the built-in defaults are used,
 *  so the site never shows blanks. */
export function SiteContentProvider({ children }) {
  const [overrides, setOverrides] = useState({});
  const [loaded, setLoaded] = useState(false);

  const reload = useCallback(async () => {
    try {
      const { data } = await api.get("/site/content");
      if (data && typeof data === "object") setOverrides(data);
    } catch { /* keep defaults */ }
    setLoaded(true);
  }, []);

  useEffect(() => { reload(); }, [reload]);

  const value = useMemo(() => ({
    get: (key) => (overrides[key] !== undefined && overrides[key] !== null ? overrides[key] : DEFAULTS[key]),
    overrides, reload, loaded,
  }), [overrides, reload, loaded]);

  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export const useContent = () => useContext(Ctx);
